import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { TranslationCacheBusterService } from './translation-cache-buster.service';

@Injectable({
    providedIn: 'root'
})
export class TranslocoHttpLoader implements TranslocoLoader
{

    constructor(private _httpClient: HttpClient,
                private _cacheBuster: TranslationCacheBusterService,
    ) {}

    getTranslation(lang: string): Observable<Translation> {
        const cacheBustedUrl = this._cacheBuster.getTranslationUrl('./assets/i18n/', lang);
        return this._httpClient.get<Translation>(cacheBustedUrl);
    }
}
